import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  ProductVariationByBarcodeResponse,
  Return,
  ReturnPayloadType,
  SearchOrdersParams,
  SearchOrdersResponse,
} from './types'

export interface ApiResponse<T> {
  status: boolean
  data: T
}

export class ReturnsServices {
  static getReturns(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<Return[]>> {
    return apiService.get<AxiosResponse<Return[]>>('/return', config)
  }

  static getReturnById(id: string): Promise<AxiosResponse<Return>> {
    return apiService.get(`/return/${id}`)
  }

  static createReturn(data: ReturnPayloadType): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/return', data)
  }

  static searchOrdersWithFilters = async (
    params: SearchOrdersParams,
  ): Promise<AxiosResponse<SearchOrdersResponse>> => {
    return apiService.get('order/searchOrders', { params })
  }

  static getProductVariationByBarcode(
    barcode: string,
  ): Promise<AxiosResponse<ProductVariationByBarcodeResponse>> {
    return apiService.get(`/products/variation/barcode/${barcode}`)
  }
}
